import { componentQrl, inlinedQrl, _jsxBranch, useStylesScopedQrl, useComputedQrl, useLexicalScope, _jsxQ, _jsxC, _IMMUTABLE, _fnSignal } from "@builder.io/qwik";
import { Blocks } from "../../components/blocks/blocks.qwik.mjs";
import { DynamicRenderer } from "../../components/dynamic-renderer/dynamic-renderer.qwik.mjs";
import { InlinedStyles } from "../../components/inlined-styles.qwik.mjs";
import { getSizesForBreakpoints } from "../../constants/device-sizes.qwik.mjs";
import { deoptSignal } from "../../functions/deopt.qwik.mjs";
import { getClassPropName } from "../../functions/get-class-prop-name.qwik.mjs";
import { mapStyleObjToStrIfNeeded } from "../../functions/get-style.qwik.mjs";
import { getColumnsClass } from "./helpers.qwik.mjs";
const getTagName = function getTagName2(props, state, gutterSize, cols, stackAt, flexDir, column) {
  return column.link ? props.builderLinkComponent || "a" : "div";
};
const getWidth = function getWidth2(props, state, gutterSize, cols, stackAt, flexDir, index) {
  var _a;
  return ((_a = cols.value[index]) == null ? void 0 : _a.width) || 100 / cols.value.length;
};
const getColumnCssWidth = function getColumnCssWidth2(props, state, gutterSize, cols, stackAt, flexDir, index) {
  const width = getWidth(props, state, gutterSize, cols, stackAt, flexDir, index);
  const subtractWidth = gutterSize.value * (cols.value.length - 1) * (width / 100);
  return `calc(${width}% - ${subtractWidth}px)`;
};
const getTabletStyle = function getTabletStyle2(props, state, gutterSize, cols, stackAt, flexDir, { stackedStyle, desktopStyle }) {
  return stackAt.value === "tablet" ? stackedStyle : desktopStyle;
};
const getMobileStyle = function getMobileStyle2(props, state, gutterSize, cols, stackAt, flexDir, { stackedStyle, desktopStyle }) {
  return stackAt.value === "never" ? desktopStyle : stackedStyle;
};
const columnsCssVars = function columnsCssVars2(props, state, gutterSize, cols, stackAt, flexDir) {
  return {
    "--flex-dir": flexDir.value,
    "--flex-dir-tablet": getTabletStyle(props, state, gutterSize, cols, stackAt, flexDir, {
      stackedStyle: flexDir.value,
      desktopStyle: "row"
    })
  };
};
const columnCssVars = function columnCssVars2(props, state, gutterSize, cols, stackAt, flexDir, index) {
  const gutter = index === 0 ? 0 : gutterSize.value;
  const width = getColumnCssWidth(props, state, gutterSize, cols, stackAt, flexDir, index);
  const gutterPixels = `${gutter}px`;
  const mobileWidth = "100%";
  const mobileMarginLeft = 0;
  const marginLeftKey = "margin-left";
  const sharedStyles = {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch"
  };
  return {
    ...sharedStyles,
    width,
    [marginLeftKey]: gutterPixels,
    "--column-width-mobile": getMobileStyle(props, state, gutterSize, cols, stackAt, flexDir, {
      stackedStyle: mobileWidth,
      desktopStyle: width
    }),
    "--column-margin-left-mobile": getMobileStyle(props, state, gutterSize, cols, stackAt, flexDir, {
      stackedStyle: mobileMarginLeft,
      desktopStyle: gutterPixels
    }),
    "--column-width-tablet": getTabletStyle(props, state, gutterSize, cols, stackAt, flexDir, {
      stackedStyle: mobileWidth,
      desktopStyle: width
    }),
    "--column-margin-left-tablet": getTabletStyle(props, state, gutterSize, cols, stackAt, flexDir, {
      stackedStyle: mobileMarginLeft,
      desktopStyle: gutterPixels
    })
  };
};
const getWidthForBreakpointSize = function getWidthForBreakpointSize2(props, state, gutterSize, cols, stackAt, flexDir, size) {
  var _a, _b;
  const breakpointSizes = getSizesForBreakpoints(((_b = (_a = props.builderContext.content) == null ? void 0 : _a.meta) == null ? void 0 : _b.breakpoints) || {});
  return breakpointSizes[size].max;
};
const columnsStyles = function columnsStyles2(props, state, gutterSize, cols, stackAt, flexDir) {
  const childColumnDiv = `.${props.builderBlock.id}-breakpoints > .builder-column`;
  return `
        @media (max-width: ${getWidthForBreakpointSize(props, state, gutterSize, cols, stackAt, flexDir, "medium")}px) {
          .${props.builderBlock.id}-breakpoints {
            flex-direction: var(--flex-dir-tablet);
            align-items: stretch;
          }

          ${childColumnDiv} {
            width: var(--column-width-tablet) !important;
            margin-left: var(--column-margin-left-tablet) !important;
          }
        }

        @media (max-width: ${getWidthForBreakpointSize(props, state, gutterSize, cols, stackAt, flexDir, "small")}px) {
          .${props.builderBlock.id}-breakpoints {
            flex-direction: var(--flex-dir);
            align-items: stretch;
          }

          ${childColumnDiv} {
            width: var(--column-width-mobile) !important;
            margin-left: var(--column-margin-left-mobile) !important;
          }
        },
      `;
};
const getAttributes = function getAttributes2(props, state, gutterSize, cols, stackAt, flexDir, column, index) {
  return {
    ...column.link ? {
      href: column.link
    } : {},
    [getClassPropName()]: "builder-column",
    style: mapStyleObjToStrIfNeeded(columnCssVars(props, state, gutterSize, cols, stackAt, flexDir, index))
  };
};
const Columns = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  var _a;
  _jsxBranch();
  const state = {};
  useStylesScopedQrl(/* @__PURE__ */ inlinedQrl(STYLES, "Columns_component_useStylesScoped_s7JLZz7MCCQ"));
  const gutterSize = useComputedQrl(/* @__PURE__ */ inlinedQrl(() => {
    const [props2] = useLexicalScope();
    return typeof props2.space === "number" ? props2.space || 0 : 20;
  }, "Columns_component_gutterSize_useComputed_j0vfXzMKBDA", [
    props
  ]));
  const cols = useComputedQrl(/* @__PURE__ */ inlinedQrl(() => {
    const [props2] = useLexicalScope();
    return props2.columns || [];
  }, "Columns_component_cols_useComputed_aVUzM2fGqrw", [
    props
  ]));
  const stackAt = useComputedQrl(/* @__PURE__ */ inlinedQrl(() => {
    const [props2] = useLexicalScope();
    return props2.stackColumnsAt || "tablet";
  }, "Columns_component_stackAt_useComputed_62lgKFigB6o", [
    props
  ]));
  const flexDir = useComputedQrl(/* @__PURE__ */ inlinedQrl(() => {
    const [props2] = useLexicalScope();
    return props2.stackColumnsAt === "never" ? "row" : props2.reverseColumnsWhenStacked ? "column-reverse" : "column";
  }, "Columns_component_flexDir_useComputed_FDnJAkDHoLk", [
    props
  ]));
  return /* @__PURE__ */ _jsxQ("div", {
    class: getColumnsClass((_a = props.builderBlock) == null ? void 0 : _a.id) + " div-Columns",
    style: columnsCssVars(props, state, gutterSize, cols, stackAt, flexDir)
  }, null, [
    /* @__PURE__ */ _jsxC(InlinedStyles, {
      id: "builderio-columns",
      styles: columnsStyles(props, state, gutterSize, cols, stackAt, flexDir),
      get nonce() {
        return props.builderContext.nonce;
      },
      [_IMMUTABLE]: {
        id: _IMMUTABLE,
        nonce: _fnSignal((p0) => p0.builderContext.nonce, [
          props
        ], "p0.builderContext.nonce")
      }
    }, 3, "c0_0"),
    (props.columns || []).map((column, index) => {
      return /* @__PURE__ */ _jsxC(DynamicRenderer, {
        TagName: getTagName(props, state, gutterSize, cols, stackAt, flexDir, column),
        actionAttributes: {},
        attributes: getAttributes(props, state, gutterSize, cols, stackAt, flexDir, column, index),
        children: /* @__PURE__ */ _jsxC(Blocks, {
          path: `columns.${index}.blocks`,
          get parent() {
            return props.builderBlock.id;
          },
          get context() {
            return props.builderContext;
          },
          get registeredComponents() {
            return props.builderComponents;
          },
          get linkComponent() {
            return props.builderLinkComponent;
          },
          blocks: deoptSignal(column.blocks),
          get styleProp() {
            return {
              flexGrow: "1"
            };
          },
          [_IMMUTABLE]: {
            context: _fnSignal((p0) => p0.builderContext, [
              props
            ], "p0.builderContext"),
            linkComponent: _fnSignal((p0) => p0.builderLinkComponent, [
              props
            ], "p0.builderLinkComponent"),
            parent: _fnSignal((p0) => p0.builderBlock.id, [
              props
            ], "p0.builderBlock.id"),
            registeredComponents: _fnSignal((p0) => p0.builderComponents, [
              props
            ], "p0.builderComponents"),
            styleProp: _IMMUTABLE
          }
        }, 3, "c0_1"),
        [_IMMUTABLE]: {
          actionAttributes: _IMMUTABLE
        }
      }, 1, index);
    })
  ], 1, "c0_2");
}, "Columns_component_7yLj4bxdI6c"));
const STYLES = `
.div-Columns {
  display: flex;
  line-height: normal;
  height: 100%;
}
`;
export {
  Columns,
  STYLES,
  columnCssVars,
  columnsCssVars,
  columnsStyles,
  Columns as default,
  getAttributes,
  getColumnCssWidth,
  getMobileStyle,
  getTabletStyle,
  getTagName,
  getWidth,
  getWidthForBreakpointSize
};
